import { baseClient } from "./baseRequest";
import { Klydo } from "./klydo";

export type ExpirationDate = {
  day: number;
  month: number;
  year: number;
};

export type KlydoEntry = {
  klydoId: string;
  expiresAt?: ExpirationDate;
};

export type ExploreCategory = {
  id: string;
  name: string;
  description: string;
  logoUrl: string;
  klydos?: (Klydo & { favorites: number; expiresAt?: ExpirationDate })[];
  index: number;
  active: boolean;
  contentChangedTimestamp: number | null;
  autoFill: boolean;
  autoFillQuery: Record<string, unknown> | null;
  autoFillSort: Record<string, unknown> | null;
  autoFillLimit: number | null;
};

export type UpdateExploreCategoryPayload = Omit<
  Partial<ExploreCategory>,
  "klydos"
> & {
  klydos?: KlydoEntry[];
};

export type ExploreCategoriesApiClient = {
  getAllExploreCategories: () => Promise<ExploreCategory[]>;
  createExploreCategory: (
    exploreCategory: Partial<ExploreCategory>,
  ) => Promise<string>;
  updateExploreCategory: (
    exploreCategoryId: string,
    exploreCategory: UpdateExploreCategoryPayload,
  ) => Promise<void>;
  removeExploreCategory: (exploreCategoryId: string) => Promise<void>;
};

const exploreCategoriesClient: ExploreCategoriesApiClient = {
  getAllExploreCategories: async () => {
    return baseClient.get<ExploreCategory[]>({
      url: "/explore-categories",
    });
  },
  createExploreCategory: async (exploreCategory) => {
    return baseClient.post<string>({
      url: "/explore-categories",
      body: exploreCategory,
    });
  },
  updateExploreCategory: async (exploreCategoryId, exploreCategory) => {
    const { id, ...body } = exploreCategory as UpdateExploreCategoryPayload & {
      id?: string;
    };
    return baseClient.put({
      url: `/explore-categories/${exploreCategoryId}`,
      body,
    });
  },
  removeExploreCategory: async (exploreCategoryId) => {
    return baseClient.delete({
      url: `/explore-categories/${exploreCategoryId}`,
    });
  },
};

export default exploreCategoriesClient;
